import GenericOutlinesPanel from './GenericOutlinesPanel';

export default GenericOutlinesPanel;
